import React from 'react';
import styled from 'styled-components';
import { Booking } from '../components';

const PageContainer = styled.div`
  padding-top: 80px; /* Space for fixed header */
`;

const PageHeader = styled.div`
  background-color: #1e3a8a;
  color: white;
  padding: 4rem 2rem;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Playfair Display', serif;
`;

const PageDescription = styled.p`
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const BookingPage = () => {
  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Book Your Stay</PageTitle>
        <PageDescription>
          Reserve your perfect getaway at Lakeside Haven. Fill out the booking form below,
          and our team will ensure your stay is comfortable and memorable.
          For special requests or group bookings, please contact us directly.
        </PageDescription>
      </PageHeader>
      
      <Booking />
    </PageContainer>
  );
};

export default BookingPage;
